import { render, staticRenderFns } from "./RoutesEdit.vue?vue&type=template&id=57130621&scoped=true"
import script from "./RoutesEdit.vue?vue&type=script&lang=js"
export * from "./RoutesEdit.vue?vue&type=script&lang=js"
import style0 from "./RoutesEdit.vue?vue&type=style&index=0&id=57130621&prod&scoped=true&lang=css"
import style1 from "./RoutesEdit.vue?vue&type=style&index=1&id=57130621&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57130621",
  null
  
)

export default component.exports